import { Injectable } from '@angular/core';
import { WebSocketService } from '../../server-communication/services/websocket.service';
import { IConMonStatusMessage, IUserMonitoring } from '../../../../model/docking';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import { LocationContextService } from '../../location-context/location-context.service';
import { ClientsService } from '../../clients/clients.service';
import { DeviceSource } from '../../../../model/license';

@Injectable()
export class ConMonService {
    constructor(
        private readonly webSocketService: WebSocketService,
        private readonly locationContextService: LocationContextService,
        private readonly clientService: ClientsService
    ) {}

    sendStatusMessage(userName: string, operator: string) {
        const conMonStatusMessage: IConMonStatusMessage = {
            operator: operator,
            userMonitoring: {
                monitorUID: this.clientService.getCorrelationId(),
                userName
            },
            locationContext: this.locationContextService.getLocationContext()
        };
        this.webSocketService.sendMessage(WebSocketMessageType.ConMon, conMonStatusMessage);
    }

    isCurrentUser(userMonitoring: IUserMonitoring) {
        return userMonitoring.monitorUID === this.clientService.getCorrelationId();
    }
}
